import React from 'react';
import { BookOpenIcon, CircleDotIcon, ZapIcon, MessageCircleIcon, RefreshCwIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpenIcon className="w-8 h-8 text-amber-400" data-id="element-157" />,
    title: 'Guía Maestra: Sistemas ADHD para Parejas',
    description: 'Manual completo de 60 páginas con instrucciones de implementación inmediata.'
  }, {
    icon: <CircleDotIcon className="w-8 h-8 text-red-400" data-id="element-158" />,
    title: 'El Semáforo de Carga Mental',
    description: 'Plantilla imprimible para eliminar las explosiones emocionales al llegar a casa.'
  }, {
    icon: <ZapIcon className="w-8 h-8 text-yellow-400" data-id="element-159" />,
    title: 'Matriz de Intercambio de Dopamina',
    description: 'Herramienta para dividir tareas por nivel de energía, no por obligación.'
  }, {
    icon: <MessageCircleIcon className="w-8 h-8 text-teal-400" data-id="element-160" />,
    title: 'Tarjetas de Guiones de Emergencia',
    description: 'Safe Words escritas para detener discusiones circulares en 60 segundos.'
  }, {
    icon: <RefreshCwIcon className="w-8 h-8 text-blue-400" data-id="element-161" />,
    title: 'Protocolo: El Apagón del Domingo',
    description: 'Ritual de 10 minutos para sincronizar la semana y eliminar sorpresas estresantes.'
  }];
  return <section className="py-16 md:py-24 bg-[#0f172a]" data-id="element-162">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-163">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-16" data-id="element-164">
          Todo Lo Que Incluye Tu Pack
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-165">
          {items.map((item, index) => <div key={index} className={`bg-slate-800/50 p-8 rounded-2xl border border-slate-700/50 hover:border-amber-500/30 transition-colors flex flex-col h-full ${index === 0 ? 'md:col-span-2 lg:col-span-3 bg-gradient-to-br from-slate-800/80 to-slate-900/80 border-amber-900/30' : ''}`} data-id="element-166">
              <div className="bg-slate-900 w-16 h-16 rounded-xl flex items-center justify-center mb-6 shadow-inner border border-slate-800" data-id="element-167">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-168">
                {item.title}
              </h3>
              <p className="text-slate-400 leading-relaxed flex-grow" data-id="element-169">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}